"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Heading = require("./Heading.style");

var _fontSystem = require("../../utils/fontSystem");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Heading = function Heading(props) {
  var children = props.children,
      level = props.level;

  var getTag = function getTag(level) {
    return level === 'super1' || level === 'super2' || level === 'super3' ? 'h1' : level;
  };

  return _react.default.createElement(_Heading.StyledHeading, _extends({}, props, {
    as: getTag(level)
  }), children);
};
/**
 * Definition of default values for component props
 */


exports.Heading = Heading;
Heading.defaultProps = {
  children: undefined,
  level: 'h1',
  truncate: false,
  color: undefined,
  display: 'block',
  align: 'inherit',
  fontFamily: undefined,
  marginTop: '0',
  marginBottom: '1rem',
  fontWeight: undefined,
  fontStyle: _fontSystem.FONT_STYLE_DISPLAY_DEFAULT
};
Heading.propTypes = {
  /** Inner elements into the <h*> tag */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.string, _propTypes.default.element]),

  /** The heading level */
  level: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'super1', 'super2', 'super3']),

  /** If true, the text will be truncated with ellipsis fitting the wrapper element width */
  truncate: _propTypes.default.bool,

  /** The text color. If not set, it gets the default normalize color depending on the background darkness-level */
  color: _propTypes.default.string,

  /** The display CSS property for this element */
  display: _propTypes.default.oneOf(['initial', 'block', 'inline', 'inline-block']),

  /** The text alignment */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /** The text font family */
  fontFamily: _propTypes.default.string,

  /** The margin over of the heading. Include units (px, %, rem, em, ...) */
  marginTop: _propTypes.default.string,

  /** The margin below of the heading. Include units (px, %, rem, em, ...) */
  marginBottom: _propTypes.default.string,
  fontWeight: _propTypes.default.oneOf(['100', '300', '500', '900', 'bold', 'inherit', undefined]),

  /** The font and font weight combination as defined in the font system (/fonts.theme.js) */
  fontStyle: _propTypes.default.oneOf([_fontSystem.FONT_STYLE_DISPLAY_DEFAULT, _fontSystem.FONT_STYLE_DISPLAY_BLACK, _fontSystem.FONT_STYLE_REGULAR_DEFAULT, _fontSystem.FONT_STYLE_REGULAR_LIGHT, _fontSystem.FONT_STYLE_REGULAR_LIGHT_ITALIC, _fontSystem.FONT_STYLE_REGULAR_BOLD, _fontSystem.FONT_STYLE_REGULAR_BOLD_ITALIC, _fontSystem.FONT_STYLE_EMPHASIS_DEFAULT, _fontSystem.FONT_STYLE_EMPHASIS_LIGHT, _fontSystem.FONT_STYLE_EMPHASIS_LIGHT_ITALIC, undefined])
};